import { useEffect } from "react";
import { Outlet, useLocation, useNavigationType } from "react-router";
import { BottomTab } from "./bottom-tab";

export function MainLayout() {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType !== "POP") {
      window.scrollTo(0, 0);
    }
  }, [pathname, navigationType]);

  return (
    <div
      className="flex min-h-dvh flex-col overflow-x-clip"
      style={{ paddingTop: "var(--safe-area-inset-top)" }}
    >
      <main
        className="flex flex-1 flex-col"
        style={{ paddingBottom: "calc(56px + var(--safe-area-inset-bottom))" }}
      >
        <Outlet />
      </main>
      <BottomTab />
    </div>
  );
}
